// extracted by mini-css-extract-plugin
module.exports = {"DeleteBtnContainer":"_1siIdeeYtUa6sBU0fT2Vzm"};